import './PreventiveIssueCreateFooter.scss';

import { useViolationsCreateForm } from "../../../../../hooks/useViolationsCreateForm";

import { Button } from "../../../../../common-components/Buttons/Buttons";

const PreventiveIssueCreateFooter = ({id}) => {
    const { handleSend } = useViolationsCreateForm({id});

    return (
        <div className={"preventive-issue-create-footer"}>
            <Button title={"Добавить"} onClick={handleSend}/>
        </div>
    )
}

export default PreventiveIssueCreateFooter;